const { types, cardComponentName, searchApiUrl } = require('../../_utilities/types');
const createAdcellQueryParams = require('../../_utilities/create-adcell-query-params');

let amountOfSearchesRunning = 0;

const sanitizeQuery = (query) => {
  if (!query) {
    return query;
  }
  // Replace >< with space
  const sanitizedQuery = query.replace(/><|<|>/g, ' ');
  return sanitizedQuery;
};
(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      default:
        break;

      case 'SETSEARCHHASRUN':
        state.searchHasRunOnce = true;
        break;

      case 'UPDATE':
        state.q = sanitizeQuery(action.value.q);
        state[action.value.type] = action.value.items;
        state[`${action.value.type}Order`] = action.value.order;
        state[`${action.value.type}TotalCount`] = action.value.totalCount;
        break;

      case 'CLEAR_ALL':
        types.forEach((type) => {
          state[type] = [];
          state[`${type}Order`] = 'best_match';
          state[`${type}TotalCount`] = '';
        });
        break;
    }

    return state;
  };

  window.swinger.app({
    type: 'mixed-results',
    component: 'mixed-results',
    reducer: reducer(),
  })
    .then((app) => {
      window.swinger.i18n()
        .then((i18n) => {
          const itemsPerPage = 36;
          const url = new URL(window.location);
          const params = url.searchParams;
          const state = app.store.getState();
          const searchTerm = (() => {
            if (params.get('q')) {
              return params.get('q');
            }

            if (state.q) {
              return state.q;
            }

            if (location.pathname !== window.swinger.config.pages.search) {
              const pathParts = location.pathname.split('/');
              const lastPathPart = pathParts.pop().split('.')[0];
              const cleanedLastPathPart = lastPathPart
                .replace(/[^a-z]/ig, ' ')
                .replace(/\s+/g, ' ')
                .trim();

              return cleanedLastPathPart;
            }

            return undefined;
          })();
          const q = searchTerm ? sanitizeQuery(searchTerm) : undefined;

          window.swinger.webworker.filterWorker.addEventListener('message', (e) => {
            if (e.data.action !== 'result') {
              return;
            }

            // If user searches for product number redirect to page
            if (
              q
          && e.data.totalItemCount === 1
          && e.data.result[0]
          && e.data.result[0].href
          && e.data.result[0].identifiers
          && e.data.result[0].identifiers.indexOf(q.toUpperCase().trim()) > -1
            ) {
              window.location = e.data.result[0].href;
              return;
            }

            app.store.dispatch({
              type: 'UPDATE',
              value: {
                type: e.data.type,
                q: sanitizeQuery(q),
                items: e.data.result.map((item) => ({
                  component: cardComponentName[e.data.type],
                  data: item,
                })),
                order: e.data.order,
                totalCount: Number(e.data.totalItemCount),
              },
            });

            window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
            amountOfSearchesRunning = Math.max(amountOfSearchesRunning - 1, 0);

            if (amountOfSearchesRunning === 0) {
              const state = app.store.getState();

              app.store.dispatch({
                type: 'SETSEARCHHASRUN',
              });

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'search_result',
                template: 'search',
                search_term: `${state.q.toLowerCase()}`,
                movie_count: `${state.moviesTotalCount || 0}`,
                scene_count: `${state.scenesTotalCount || 0}`,
                studio_count: `${state.studiosTotalCount || 0}`,
                pornstar_count: `${state.performersTotalCount || 0}`,
                clip_count: `${state.clipsTotalCount || 0}`,
                amateur_count: `${state.amateursTotalCount || 0}`,
              });
            }

            if (['movies', 'scenes', 'clips'].indexOf(e.data.type) > -1) {
              const adCellQueryParams = createAdcellQueryParams({
                pageType: 'search',
                q,
                itemIds: e.data.result.map((item) => item.itemNumber),
              });

              // Safeguards against a head/foot JS mismatch
              if (
                window.swinger.retargeting
            && window.swinger.retargeting.adcell
            && window.swinger.retargeting.adcell.container
              ) {
                window.swinger.retargeting.adcell.container(adCellQueryParams);
              }
            }
          });

          const retrieve = () => {
            if (state.isErrorPage) {
              document.title = `${i18n('ui.mixed-results.headline.error-page')}: ${i18n('ui.mixed-results.subheadline.error-page', {
                q: sanitizeQuery(q),
              })}`;
            } else {
              document.title = i18n('ui.mixed-results.headline', {
                q: sanitizeQuery(q),
              });
            }

            types.forEach((type) => {
              const search = `q=${encodeURIComponent(q)}`;

              window.setTimeout(() => {
                window.swinger.webworker.filterWorker.postMessage({
                  action: 'retrieve',
                  url: `${window.swinger.config.apiBase}${searchApiUrl[type]}`,
                  language: window.swinger.config.language,
                  search,
                  source: 'search',
                  referrer: window.location.href,
                  itemsPerPage,
                  pageNumber: 1,
                  version: window.swinger.config.version,
                });
              }, type === 'movies' ? 0 : 200);

              amountOfSearchesRunning += 1;
            });

            window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:show');
          };

          if (q) {
            retrieve();
          } else {
            app.store.dispatch({
              type: 'CLEAR_ALL',
            });
          }
        })
        .catch(console.info);
    })
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/mixed-results/mixed-results.js